<template>
  <div class="teacher-schedule">
    <Title :title="scheduleTitle" :english-title="scheduleEnglishTitle" mode="white"></Title>
    <schedule-center :admin-center-url="adminCenterUrl" :base-url="serveUrl" :request="request" :show-calendar="false" :view-switch="false" :show-filter="false" />
    <SeeMore :next="scheduleNext" :name="name"></SeeMore>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Title from "../components/Title";
import SeeMore from "../components/SeeMore";

export default {
  name: "Schedule",
  data() {
    return {
      name:'全部日程',
      scheduleTitle: "我的日程",
      scheduleEnglishTitle: "my schedule",
      scheduleNext: { next: "ScheduleCenter" }
    };
  },
  components: {
    Title,
    SeeMore
  },
  computed: {
    ...mapGetters(["serveUrl", "idToken", "request", "adminCenterUrl"])
  }
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";

.teacher-schedule {
  position: relative;
  min-height: calc(100vh - 60px);
  overflow: hidden;
  background-color: rgba(0, 50, 100, 1);
  @include contentMedia;

  .components-title {
    padding-top: 50px;
    padding-bottom: 40px;
  }

  .schedule-center {
    height: 800px;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: $shadow-primary;
  }

  .see-more {
    margin-top: 40px;
    margin-bottom: 50px;
    color: #fff;
    border: 1px solid #fff;
  }
}
</style>
